import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ROUTES } from '@/config/routes';

const TeamPage = lazy(() => import('./routes/TeamPage').then((m) => ({ default: m.TeamPage })));

// Its own chunk, and worth one: most visits to /team never open it, and the form carries
// the role list and the product picker with it.
const AddTeamMemberPage = lazy(() =>
  import('./routes/AddTeamMemberPage').then((m) => ({ default: m.AddTeamMemberPage })),
);
const EditTeamMemberPage = lazy(() =>
  import('./routes/EditTeamMemberPage').then((m) => ({ default: m.EditTeamMemberPage })),
);

/**
 * The Team screen's routes.
 *
 * <p>Lazy, like every other feature: the people who never open it never download it.
 *
 * <p>Listed before the placeholder routes so it wins — `placeholderRoutes` is derived from
 * `NAV_ITEMS` and still produces a `/team` entry. That entry disappears on its own once
 * this route is added to `BUILT_ROUTES`, which is the next line to change.
 */
export const teamRoutes: RouteObject[] = [
  { path: ROUTES.team, element: <TeamPage /> },
  { path: ROUTES.teamAdd, element: <AddTeamMemberPage /> },

  // The pattern, not a URL: `:externalId` is filled in by `routeTo.teamEdit(id)`.
  { path: ROUTES.teamEdit, element: <EditTeamMemberPage /> },
];
